
define('text!templates/layouts/content/layout-info.html',[],function () { return '<div id="info-content" class="column"></div>\n<div id="info-drawer" class="column"></div>\n';});

